
import React from 'react'
import Button from './Button'
import TextInput from './TextInput'
import TextInputField from './TextInputField'
import TaxTypeSelect from './TaxTypeSelect'
import AddressInputs from './AddressInputs'
import usePending from '@apex/lib/hooks/usePending'
import Form from './Form'

// TODO: address should not be required in BillingForm

/**
 * BillingForm is a billing form.
 */

export default function BillingForm({ team, onSubmit, ...props }) {
  const { name, email, tax_id, tax_type } = team
  const [pending, submit] = usePending(onSubmit)
  return <Form onSubmit={submit} {...props}>
    <Form.Row>
      <TextInput name="team_id" type="hidden" value={team.id} />
      <TextInputField
        defaultValue={name}
        width="100%"
        type="name"
        name="name"
        label="Name"
        placeholder="Apex Software"
        required />
    </Form.Row>
    <Form.Row>
      <TextInputField
        defaultValue={email}
        width="100%"
        type="email"
        name="email"
        label="Email"
        placeholder="hello@example.com"
        required />
    </Form.Row>
    <AddressInputs {...team} required={false} />
    <Form.Row>
      <TaxTypeSelect
        defaultValue={tax_type}
        label="Tax ID Type"
        name="tax_type" />
      <TextInputField
        defaultValue={tax_id}
        width="100%"
        name="tax_id"
        label="Tax ID"
        placeholder="DQ123456C" />
    </Form.Row>
    <Form.Actions>
      <Button theme="primary" pending={pending}>Save settings</Button>
    </Form.Actions>
  </Form>
}
